import {
  CODE_PATTERN,
  PARTNER_PATTERN,
  STATUSES,
  parseDiscount,
  parseExpiryDays,
} from "../partnerShared";

const validWholeNumber = (value, parse) =>
  /^\d+$/.test(String(value)) && parse(value) !== null;

export function validatePartnerForm(form, campaigns) {
  if (!form) return {};
  const errors = {};
  const name = form.partner_name.trim().toLowerCase();
  if (!name) errors.partner_name = "Enter a partner name.";
  else if (!PARTNER_PATTERN.test(name)) {
    errors.partner_name =
      "Use up to 64 lowercase letters, numbers, hyphens or underscores, without spaces.";
  } else if (
    form.mode === "create" &&
    campaigns.some((item) => item.partner_name === name)
  ) {
    errors.partner_name =
      "This partner already exists. Choose another name or edit the existing partner.";
  }
  if (!validWholeNumber(form.discount_value, parseDiscount)) {
    errors.discount_value = "Enter a whole number from 0 to 100.";
  }
  if (!validWholeNumber(form.expiry_days, parseExpiryDays)) {
    errors.expiry_days = "Enter a whole number from 1 to 3650 days.";
  }
  if (form.mode === "create" && !form.api_key) {
    errors.api_key = "Generate a connection key before creating this partner.";
  }
  return errors;
}

export function partnerHasChanges(form) {
  if (!form) return false;
  if (form.mode === "create" || !form.original) return true;
  return (
    parseDiscount(form.discount_value) !==
      Number(form.original.discount_value) ||
    parseExpiryDays(form.expiry_days) !== Number(form.original.expiry_days) ||
    form.is_active !== (form.original.is_active !== false) ||
    form.keyIsNew ||
    form.applyDiscount ||
    form.applyExpiry
  );
}

export function validatePromoCodeForm(form, campaigns) {
  if (!form) return {};
  const errors = {};
  const creating = form.mode === "create";
  const partner = form.partner_name.trim().toLowerCase();
  if (
    !PARTNER_PATTERN.test(partner) ||
    (creating && !campaigns.some((item) => item.partner_name === partner))
  ) {
    errors.partner_name = "Choose a partner from the list.";
  }
  const code = form.promo_code.trim().toUpperCase();
  if ((!creating || code) && !CODE_PATTERN.test(code)) {
    errors.promo_code = "Use 4 to 32 letters, numbers or hyphens.";
  }
  if (
    (!creating || form.discount_value !== "") &&
    !validWholeNumber(form.discount_value, parseDiscount)
  ) {
    errors.discount_value = "Enter a whole number from 0 to 100.";
  }
  if (creating) {
    if (
      form.expiry_days !== "" &&
      !validWholeNumber(form.expiry_days, parseExpiryDays)
    ) {
      errors.expiry_days = "Enter a whole number from 1 to 3650 days.";
    }
  } else {
    if (!form.expires_at || Number.isNaN(new Date(form.expires_at).getTime())) {
      errors.expires_at = "Choose a valid expiry date and time.";
    }
    if (!STATUSES.includes(form.status))
      errors.status = "Choose a status from the list.";
  }
  if (form.external_reference_id.trim().length > 128) {
    errors.external_reference_id =
      "Keep the reference to 128 characters or fewer.";
  }
  return errors;
}
